
// import axios from '@/classes/myAxios'
import axios from '@/classes/myAxios'

// import { getKey } from 'apollo-link/lib/linkUtils';


export default{

    async setAll(key, tokenId, accessToken, refreshToken){
        
        // console.log(`in setall`);

        let result;

        // if(process.env.VUE_APP_SERVER_MY_MODE == 'development'){
        if(process.env.NODE_ENV == 'development' && process.env.VUE_APP_SERVER_MY_MODE == 'development'){
            
            result = await axios({method: 'post',url: 'http://localhost:3000/pnadiapi/setall',
            data: {key: key, tokenId: tokenId, accessToken: accessToken, refreshToken: refreshToken, expires:''}});

        }else{

            result = await axios({method: 'post',url: '/pnadiapi/setall',
            data: {key: key, tokenId: tokenId, accessToken: accessToken, refreshToken: refreshToken, expires:''}});

        }
        // console.log(`from setAll result back is ${JSON.stringify(result)}`);

        return result;
    },

    async getAll(key){
        
        // console.log(`in getAll`);

    //    console.log(`Im in http with key ${key}`);
        let result;
        
        // if(process.env.VUE_APP_SERVER_MY_MODE == 'development'){
            if(process.env.NODE_ENV == 'development' && process.env.VUE_APP_SERVER_MY_MODE == 'development'){

            result = await axios({method: 'post',url: 'http://localhost:3000/pnadiapi/getall',
            data: {key: key}});

        }else{

            // console.log(`in production`);

            result = await axios({method: 'post',url: '/pnadiapi/getall',
            data: {key: key}});

        }

        // console.log(`Im in get all http and result is ${JSON.stringify(result)}`);

        return result;
    },

    async getToken(key){

        // console.log(`in getToken`);

        let result;
        // console.log(`Im in get token and key is ${key}`);
        // if(process.env.VUE_APP_SERVER_MY_MODE == 'development'){
            if(process.env.NODE_ENV == 'development' && process.env.VUE_APP_SERVER_MY_MODE == 'development'){

            // console.log(`in development`);

            result = await axios({method: 'post',url: 'http://localhost:3000/pnadiapi/getidtoken',
             data: {key: key}});
        }
        else{

            result = await axios({method: 'post',url: '/pnadiapi/getidtoken',
             data: {key: key}});
        }
          
        //  console.log(`Im in http and result is ${JSON.stringify(result)}`);

         return result;
 
     },

    async deleteAll(email){

        let result;
        // if(process.env.VUE_APP_SERVER_MY_MODE == 'development'){
            if(process.env.NODE_ENV == 'development' && process.env.VUE_APP_SERVER_MY_MODE == 'development'){

            result = await axios({method: 'post',url: 'http://localhost:3000/pnadiapi/deleteall',
            data: {email: email}});
        }
        else{
        
            result = await axios({method: 'post',url: '/pnadiapi/deleteall',
            data: {email: email}});
        }
         

        return result;            
    },


    getKey(){

        // console.log(`in get key with: ${localStorage.getItem('for_pnadi')}`);
        return localStorage.getItem('for_pnadi')

    }
    // async setValue(key, value){


    // },

    // async getValue(key){


    // },

    // async getExpires(){


    // }
}